export default __webpack_public_path__ + "files/thumbnail-b070ad140526e6d23f58370936fd9e6a.png";